export default "__VITE_ASSET__BmHFeyoa__"